import { render, staticRenderFns } from "./classifyBar.vue?vue&type=template&id=21ffb4ab&scoped=true"
import script from "./classifyBar.vue?vue&type=script&lang=js"
export * from "./classifyBar.vue?vue&type=script&lang=js"
import style1 from "./classifyBar.vue?vue&type=style&index=1&id=21ffb4ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ffb4ab",
  null
  
)

export default component.exports